<template>
    <div class="_v-autocomplete-container" ref="autocompleteContainer">
        <slot :search="search">
            <input type="search" class="form-control" v-model="search.value" autocomplete="false" ref="searchInput" :readonly="readonly" @blur="hideList"
                placeholder="Clicca e scrivi per cercare" @focus="canShowList = true" />
        </slot>
        <div class="_v-autocomplete-list" ref="autocompleteList">
            <div class="_v-autocomplete-list-item" :class="{'active': selectedIndex == i }" 
                v-for="(item, i) in results" :key="'listItem' + i" @click="setResult(item)">
                <slot :item="item" name="list-item">
                    {{item}}
                </slot>  
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import WithModel from "@/mixins/withModel";
import { mixins, Options } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

function delegate(el, evt, sel, handler) {
    el.addEventListener(evt, function(event) {
        var t = event.target;
        while (t && t !== this) {
            if (t.matches(sel)) {
                handler.call(t, event);
            }
            t = t.parentNode;
        }
    });
}

@Options({})
export default class vAutocomplete extends mixins(WithModel) {

    @Prop({
        type: [Object, Function]
    }) searchCallback: any;
    @Prop({
        type: [Object, Function]
    }) printCallback: any;
    @Prop({
        type: [Object, Function]
    }) resultCallback: any;
    @Prop() readonly: boolean;
    
    results = [];
    autoCompleteListHeight = 0;
    search: any = { value: '' };
    selectedIndex: number = 0;
    canShowList: boolean = false;

    created(){
        if(this.modelValue){
            this.onLocalValueValueChange(this.modelValue);
        }
    }

    @Watch('localValue')
    onLocalValueValueChange(next){
        if(next){
            let items = this.searchCallback(next);
            if(items.length > 0)
                this.search.value = this.printCallback(items[0]);
        } else {
            this.search.value = '';
        }
    }

    setResult(item){
        this.search.value = this.printCallback(item);
        this.emitModel(this.resultCallback(item));
        (this.$refs.searchInput as HTMLInputElement).focus();
    }

    @Watch('search.value')
    onSearchChange(next, prev){

        this.selectedIndex = 0;
        if(this.readonly){
            this.results = [];
        } else if(this.searchCallback){
            this.results = this.searchCallback(next);
        }
        if(!this.search.value){
            this.setResult('');
        }
        
        this.$nextTick( () => {
            //this.autocompleteList: HTMLElement = <HTMLElement>this.$refs.autocompleteList;
            this.autocompleteList.scrollTo(0, 0);
            this.autoCompleteListHeight = this.autocompleteList.offsetHeight;
            if(this.results.length == 0){
                this.hideList();
            } else {
                if(this.canShowList){
                    this.autocompleteList.style.display = 'block';
                }
            }
        })
    }

    hideList(){
        setTimeout(() => {
            if(this.autocompleteList){
                this.autocompleteList.style.display = 'none';
            }
        }, 100)
    }

    container: HTMLElement = null;
    autocompleteList: HTMLElement = null;
    mounted(){
        this.container = this.$refs.autocompleteContainer as HTMLElement;
        this.autocompleteList = this.$refs.autocompleteList as HTMLElement;
        if(this.readonly)
            this.hideList();

        delegate(this.container, 'keydown', 'input', (ev) => {
            let listItem = this.autocompleteList.querySelector('._v-autocomplete-list-item');
            if(!listItem)
                return;
            let itemHeight = parseInt(getComputedStyle(listItem).height);
            let maxItems = Math.floor(this.autoCompleteListHeight / itemHeight);

            if(!ev.key)
                return;
            if(ev.key == "ArrowUp"){
                if(this.selectedIndex > 0)
                    this.selectedIndex--;
                this.autocompleteList.scrollTop -= itemHeight;
            } else if(ev.key == "ArrowDown") {
                if(this.selectedIndex < this.results.length - 1)
                    this.selectedIndex++;

                if((this.selectedIndex + 1) / maxItems > 1){
                    this.autocompleteList.scrollTop += itemHeight;
                }
            } else if(ev.key == "Enter") {
                this.setResult(this.results[this.selectedIndex]);
            }
        })
    }


}
</script>

<style scoped>

._v-autocomplete-container {
    position: relative;
}

._v-autocomplete-list {
    display: none;
}

._v-autocomplete-container input:focus + ._v-autocomplete-list,._v-autocomplete-container ._v-autocomplete-list:active {
    display: block;
}

._v-autocomplete-list {
    position: absolute;
    background: white;
    z-index: 2;
    cursor: pointer;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    border-left: 1px solid #f1f1f1;
    border-right: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
}

._v-autocomplete-list-item.active {
    background: #900c31;
    color: white
}

    ._v-autocomplete-list ._v-autocomplete-list-item{
        padding-left: 10px;
    }

        ._v-autocomplete-list ._v-autocomplete-list-item:hover{
            background: #900c31;
            color: white
        }
</style>